import addKeyLocalStorage from './localStorage'

export const HOME_CACHE_KEY = addKeyLocalStorage('HOME_CACHE')
export const HOME_CACHE_TTL = 60 * 60 * 1000 // 1h

export function loadHomeCache() {
  try {
    const raw = localStorage.getItem(HOME_CACHE_KEY)
    if (!raw) return null

    const parsed = JSON.parse(raw)
    if (!parsed?.timestamp || !parsed?.data) return null

    if (Date.now() - parsed.timestamp > HOME_CACHE_TTL) return null

    return parsed.data
  } catch {
    return null
  }
}

export function saveHomeCache(data) {
  try {
    localStorage.setItem(
      HOME_CACHE_KEY,
      JSON.stringify({
        timestamp: Date.now(),
        data
      })
    )
  } catch {}
}
